import * as React from "react"
import {useEffect} from "react";
import { Box } from "@mui/material"

import { CommonFilters } from "@components"
import {COMMON_FILTER_KEYS, MARKETPLACES_ROUTES} from "@constants";
import { useAppDefaultFilters } from "@hooks";
import { marketplacesLBBIsEmpty } from "./@signals";
import {isLoadingCommonFilters, isSystemBusy} from "@signals";


export default function MarketplacesLBBFilters() {

	const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(MARKETPLACES_ROUTES.LBBDETAILS_ID, MARKETPLACES_ROUTES.ACCESS_KEY)

	useEffect(() => {
		callUserDefaultFilters()
	}, [])

	return <Box data-tour="lbb-details-filters">
	<CommonFilters
		components={{
			country: true, site: true,
			category: true, brand: true,
			sku: true, favFilters: true,
			favFiltersOnlyLine: true, skuGroup: true,
			lostReason: true
		}}
		compProps={{
			favFilters: {
				grid: { md: 3 },
				allowedFilters: [
					COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.CATEGORY, COMMON_FILTER_KEYS.BRAND,
					COMMON_FILTER_KEYS.SKU_GROUP, COMMON_FILTER_KEYS.SKU, COMMON_FILTER_KEYS.LOST_BUY_BOX_REASON
				],
				dashboardKey: MARKETPLACES_ROUTES.LBBDETAILS_ID
			},
			sku: { grid: { md: 3 } },
			lostReason: { grid: { md: 3 } },
			country: { filters: { websiteType: "2" } },
			site: { filters: { websiteType: "2" } }
		}}
		onSubmit={() => {
			marketplacesLBBIsEmpty.value = false
			isSystemBusy.value = false
			isLoadingCommonFilters.value = true
		}}
		defaultValues={userFilters}
		isLoadingDefaultFilters={isLoadingDefaultFilters}
	/>
	</Box>
}
